<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row>
          <v-col cols="12" class="pa-8">
            <v-btn 
              @click="newTypeFeaturedSponsor"
              color="primary">
              Nuevo tipo de Sponsor
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              class="pt-8"
              :headers="headers"
              :items="types_featured_sponsors"
              :custom-filter="customSearch"
              :items-per-page="30"
              :header-props="headerProps"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100],
                'items-per-page-text':'Tipos de sponsors por página',
              }"
              mobile="true"
            >
              <template v-slot:item.is_visible="{ item }">
                <td class="text-center">{{ item.is_visible==1?'Visible':'No visible' }}</td>
              </template>
              <template v-slot:item.actions="{ item }">
                <td class="text-center">
                  
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    outlined
                    color="black"
                    @click="moveUp(item.id)"
                  >
                    <v-icon dark small>
                      mdi-arrow-up
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    outlined
                    color="black"
                    @click="moveDown(item.id)"
                  >
                    <v-icon dark small>
                      mdi-arrow-down
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="info"
                    :to="{ name: 'featuredSponsorsEdition', params: {edition_id:edition_id, types_feature_sponsor_id: item.id } }"
                  >
                    <v-icon dark small>
                      mdi-format-list-bulleted
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="warning"
                    @click="editTypeFeaturedSponsor(item.id)"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="red"
                    @click="confirmDeleteEdition(item.id)"
                  >
                    <v-icon dark small>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'editEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        color="primary"
        :to="{ name: 'showAllFeaturedSponsorsEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-eye
        </v-icon>
        Vista previa
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_new"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h6">
          NUEVO TIPO DE SPONSOR
        </v-card-title>

        <v-card-text class="pa-8">
          <v-text-field label="Nombre" v-model="name"></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_new=!dialog_new"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="!name"
            :loading="dialog_new_edition"
            @click="create"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_edit"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Editar tipo de patrocinador 
        </v-card-title>

        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="8">
              <v-text-field label="Nombre" v-model="name"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-switch
                v-model="is_visible"
                :label="(is_visible)?'Visible':'No visible'"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_edit = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading_edit"
            @click="updateTypeFeaturedSponsor"
          >
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_delete"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          ¿Está seguro que desea borrar este tipo de patrocinador? Todo los patrocinadores
          relacionados a este tipo se borraran también.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_delete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="deleteTypeFeaturedSponsor"
          >
            Borrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'typeFeaturedSponsorsEdition',

    data: () => ({
      loading:true,
      loading_edit: false,
      show:false,
      
      dialog_new:false,
      dialog_new_edition:false,
      dialog_edit:false,
      dialog_delete:false,
      edit_id:null,
      delete_id:null,
      name:'',
      is_visible:false,

      edition_id: false,

      types_featured_sponsors:[],
      type_featured_sponsor:[],

      headerProps: {
        sortByText: "Ordenar por"
      },
      headers: [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'order',
          width: '5%'
        },
        {
          text: 'Tipo de sponsor',
          align: 'start',
          sortable: true,
          value: 'name',
          width: '40%'
        },
        {
          text: 'Estado',
          align: 'center',
          sortable: true,
          value: 'is_visible',
          width: '15%'
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '40%'
        }
      ],

      attrs: {
        boilerplate: false,
      },
    }),

    methods:{
      customSearch (value, search, item) {
          return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
      },
      
      filterOnlyCapsText (value, search, item) {
        console.log(item)
        return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
      },

      async getTypeFeaturedSponsors()
      {
        await axios.get('admin/editions/'+this.edition_id+'/types-featured-sponsors').then(response =>{
          this.types_featured_sponsors = response.data.data.types_featured_sponsors
          this.loading=false
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      newTypeFeaturedSponsor()
      {
        this.name = ''
        this.dialog_new = true
      },

      async create()
      {
        try {
          this.dialog_new_edition = true
          await axios.post('admin/editions/'+this.edition_id+'/types-featured-sponsors',{
            name: this.name, 
            edition_id: this.edition_id
            }).then(() =>{
              this.dialog_new_edition = false
              this.dialog_new = false
              this.loading = true
              this.getTypeFeaturedSponsors()
            })
          } catch (error) {
            this.dialog_new_edition = false
            console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          }
      },

      async editTypeFeaturedSponsor(id)
      {
        this.loading = true
        this.loading_edit = false
        this.edit_id = id
        await axios.get('admin/editions/'+this.edition_id+'/types-featured-sponsors/'+this.edit_id).then(response =>{
          this.type_featured_sponsor = response.data.data.type_featured_sponsor
          this.name = this.type_featured_sponsor.name
          this.is_visible = this.type_featured_sponsor.is_visible
          this.loading=false
          this.dialog_edit = true
        }).catch(error => {
          console.log(error);
        })
      },

      async updateTypeFeaturedSponsor()
      {
        this.loading_edit = true
        await axios.put('admin/editions/'+this.edition_id+'/types-featured-sponsors/'+this.edit_id, {
          name: this.name,
          is_visible: this.is_visible
        }).then(() =>{
          this.getTypeFeaturedSponsors()
          this.loading = true
          this.loading_edit = false
          this.dialog_edit = false
        }).catch(error => {
          console.log(error);
        })
      },

      confirmDeleteEdition(id)
      {
        this.dialog_delete = true
        this.delete_id = id
      },

      async deleteTypeFeaturedSponsor()
      {
        this.dialog_delete = false
        try {
          this.loading=true
          await axios.delete('admin/editions/'+this.edition_id+'/types-featured-sponsors/'+this.delete_id).then(() =>{
            this.loading = true
            this.getTypeFeaturedSponsors()
            this.delete_id = null
          })
        } catch (error) {
          console.error(error.response.data);
        }
      },

      async moveUp(id){
        this.loading = true
        try{
          await axios.put('admin/editions/'+this.edition_id+'/types-featured-sponsors/'+id+'/move-up', {
            edition_id: this.edition_id
          }).then(()=>{
            this.getTypeFeaturedSponsors()
          })
        }catch(error) {
          this.loading = false
          console.log(error)
        }
      },
      
      async moveDown(id){
        this.loading = true
        try{
          await axios.put('admin/editions/'+this.edition_id+'/types-featured-sponsors/'+id+'/move-down', {
            edition_id: this.edition_id
          }).then(()=>{
            this.getTypeFeaturedSponsors()
          })
        }catch(error) {
          this.loading = false
          console.log(error)
        }
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getTypeFeaturedSponsors()
    },
  }
</script>
